export const getAnInViewProduct = (): string => {
  const topOfControls =
    document
      .querySelector('[data-testid="component-sticky-controls"]')
      ?.getBoundingClientRect().top ?? 0;

  const productCards = document.querySelectorAll(
    '[data-testid="component-grid-column"] > [data-testid="product-card"]'
  );

  const firstCardInView = Array.from(productCards).find(
    (el) => (el as HTMLElement).getBoundingClientRect().top >= topOfControls
  );

  if (firstCardInView) {
    return (firstCardInView as HTMLElement)?.dataset.productId;
  } else {
    const lastCard = productCards[productCards.length - 1];
    return (lastCard as HTMLElement)?.dataset.productId;
  }
};
